import React from "react";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";


function pad(pad, str, padLeft) {
    if (typeof str === 'undefined')
        return pad;
    if (padLeft) {
        return (pad + str).slice(-pad.length);
    } else {
        return (str + pad).substring(0, pad.length);
    }
}

export default class SunstudyControls extends React.Component {
    constructor() {
        super();

        this.state = {};

        this.onSlide = this.onSlide.bind(this);
    }

    componentDidMount() {
        if (this.props.currentView) {
            this.calculateSliderValues(this.props.currentView);
        }
    }

    calculateSliderValues(view) {
        this.setState({
            minHour: view.starthour,
            maxHour: view.endhour,
            nImages: view.nImages,
            hours: view.endhour - view.starthour + 1,
            hourStep: 100 / 24
        });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.currentView) {
            this.calculateSliderValues(nextProps.currentView);
        }
    }

    componentDidUpdate(prevProps) {
        //this.calculateSliderValues();
    }

    onViewClick(view) {
        this.props.onViewChange(view);
    }

    onSlide(n) {
        this.setState({
            currentSlide: n,
        });

        this.props.onSlide(n);
    }

    render() {
        if (!this.state.minHour) {
            return null;
        }

        let hours = this.state.maxHour - this.state.minHour;
        let step = this.state.nImages / hours;
        let currentHour = Math.round(this.props.currentSlide / (step)) + this.state.minHour;

        let cols = [];
        for (let i = 1; i <= 24; i++) {
            /*cols.push((<td key={i}
             className={i < this.state.minHour || i > this.state.maxHour ? 'time-col disabled' : 'time-col'}>{ pad('00', i, true)}</td>))*/

            cols.push((<div key={i} data-time={i}
                            className={i < this.state.minHour || i > this.state.maxHour ? 'time-col disabled' : 'time-col'}>{ pad('00', i, true)}</div>))
        }

        let viewButtons = this.props.sunstudy.dates.map(view => {
            return (<button key={view.slug} type="button" className={this.props.currentView === view ? 'active' : ''}
                            onClick={() => this.onViewClick(view)}>{view.name}</button>)
        });

        const fakeSliderLeftWidth = ((this.state.minHour - 1));// * 20) + 5;
        const fakeSliderRightWidth = ((24 - this.state.maxHour));// * 20) + 5;

        return (<div className="cw-sunstudy-controls">
            <div className="cw-sunstudy-controls-top">
                <div className="c-icon"><span className="icon icon-sun"></span></div>
                <div className="c-time-label">kl</div>
                <div className="time-cols">
                    {cols}
                    <div className="current-hour">{currentHour}</div>
                </div>
                <div className="c-view-buttons">{viewButtons}</div>
            </div>

            <div className="cw-sunstudy-controls-bottom">
                <div className="cw-sunstudy-controls-slider">
                    <div className={'fake-slider rc-slider fake-slider-w-' + fakeSliderLeftWidth}>
                        <div className="rc-slider-rail"></div>
                    </div>
                    <Slider min={1} max={this.state.nImages} onChange={this.onSlide} value={this.props.currentSlide}
                            className="real-slider cw-sunstudy-slider"/>

                    <div className={'fake-slider rc-slider fake-slider-w-' + fakeSliderRightWidth}>
                        <div className="rc-slider-rail"></div>
                    </div>

                </div>
            </div>

            <div>

            </div>
        </div>)
    }
}


// WEBPACK FOOTER //
// ./src/components/SunstudyControls.jsx